import React from 'react'
import { Bar } from 'react-chartjs-2'
import styled from 'styled-components'

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    
    @media screen and (min-width: 700px) {
        max-width: 100vw;
    }
`

const IncomeExpenseGraph = ({income, expense}) => {
    const data = {
        labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        datasets: [
            {
                label: "Income",
                data: income,
                fill: true,
                backgroundColor: '#51B4FB',
                borderColor: '#51B4FB',
            },
            {
                label: "Expenses",
                data: expense,
                fill: true,
                backgroundColor: '#FF8C66',
                borderColor: '#FF8C66'
            }
        ]
    }

    return (
        <Wrapper>
            <Bar 
                data={data}
                height={80}
                options={{
                    responsive: true,
                    legend: {
                        display: true,
                        position: 'bottom'
                    },
                    elements: {
                    },
                    scales: {
                        yAxes: [{
                            display: false,
                            grid: {
                                display: false
                            }
                        }],
                        xAxes: [{
                            gridLines: {
                                display: false
                            }
                        }]
                    }
                }}
            />
        </Wrapper>
    )
}

export default IncomeExpenseGraph